import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function usePackageFees(orderRef) {
  const { data, error, isLoading, mutate } = useSWR(
    orderRef ? `/countryzone/order/${orderRef}` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    packageFees: data,
    isLoading,
    error,
    mutate,
  };
}

export default usePackageFees;
